import { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { MdClose } from "react-icons/md";
import Loading from "../ui/Loading";

export default function GiphyModal({
  children,
  passShowGiphyModal,
  passGiphyId,
  passGiphySlug,
  passGiphyPreviewUrl,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const [gifs, setGifs] = useState([]);
  const [gifsPage, setGifsPage] = useState(1);
  const [gifsQuery, setGifsQuery] = useState();
  const [loadingMore, setLoadingMore] = useState(false);
  const { ref, inView } = useInView({ triggerOnce: true });

  const closeModal = () => {
    passShowGiphyModal(false);
    history.replaceState({}, document.title, props.returnHref);
  };

  // bouton retour
  addEventListener("popstate", (event) => {
    closeModal();
  });

  // bouton echap
  // addEventListener("keydown", (event) => {
  //   if (event.key === "Escape") {
  //     closeModal();
  //   }
  // });

  const fetchGifs = () => {
    var limit = 20;
    var offset = 0;
    if (gifsPage > 1) offset = gifsPage * limit;
    var key = "MU0hKFoFbhSBUkO52ECfEEjj5foSQrOn";

    var giphyUrl =
      "https://api.giphy.com/v1/gifs/trending?api_key=" +
      key +
      "&limit=" +
      limit +
      "&offset=" +
      offset +
      "";

    if (gifsQuery)
      giphyUrl =
        "https://api.giphy.com/v1/gifs/search?api_key=" +
        key +
        "&limit=" +
        limit +
        "&offset=" +
        offset +
        "&q=" +
        gifsQuery;

    axios.get(giphyUrl).then((response) => {
      if (response.data) {
        if (gifsPage === 1) setGifs(Array.from(response.data.data));
        else setGifs([...gifs, ...response.data.data]);
      } else {
        toast.show("Aucun gif trouvé.");
      }

      setLoading(false);
      setLoadingMore(false);
    });
  };

  const gifSearchTypeKeyboard = (query) => {
    setGifs([]);
    setGifsPage(1);
    setGifsQuery(query);
  };

  useEffect(() => {
    fetchGifs();
  }, [gifsPage, gifsQuery]);

  useEffect(() => {
    fetchGifs();
    setGifs(false);
    setGifsPage(1);
    setGifsQuery(false);
  }, []);

  const _handleLoadMore = () => {
    setGifsPage(gifsPage + 1);
    setLoadingMore(true);
  };

  useEffect(() => {
    if (inView && !loadingMore) {
      _handleLoadMore();
    }
  }, [inView]);

  return (
    <div
      className="bg-black/75 left-0 right-0 top-0 bottom-0 fixed z-50"
      onClick={() => {
        closeModal();
      }}
    >
      <div className="flex items-end sm:items-center justify-center h-full pt-12 sm:py-20 sm:max-w-lg sm:mx-auto">
        <div
          className="giphymodal-content flex flex-col bg-base-100 rounded-t-lg sm:rounded w-full sm:w-lg p-2 h-full"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="flex flex-row items-center pb-2 border-b border-base-content/10">
            <button
              onClick={() => {
                closeModal();
              }}
              className="closegiphymodal ml-2 mr-4 text-base-content/50"
            >
              <MdClose className="w-6 h-6" />
            </button>
            <div className="text-base-content text-lg font-bold">
              Ajouter un GIF
            </div>
          </div>

          <div className="pt-4 flex grow flex-col">
            <div>
              <input
                type="text"
                placeholder="Recherche GIPHY"
                className="input input-bordered w-full text-base-content"
                onChange={(event) => {
                  gifSearchTypeKeyboard(event.target.value);
                }}
              />
            </div>
            <div className="relative flex-1 pt-2">
              <div className="giphy_search_container pt-2 absolute left-0 top-0 right-0 bottom-0 overflow-y-auto text-base-content hide-scrollbar flex flex-row flex-wrap">
                {gifs
                  ? gifs.map((gif) => (
                      <div key={gif.id} className="w-1/2">
                        {gif.images.fixed_height_downsampled ? (
                          <picture
                            onClick={() => {
                              passGiphyId(gif.id);
                              passGiphySlug(gif.slug);
                              passGiphyPreviewUrl(
                                gif.images.fixed_width_small_still.url
                              );
                              passShowGiphyModal(false);
                            }}
                          >
                            <source
                              type="image/webp"
                              srcSet={gif.images.fixed_height_downsampled.webp}
                            />
                            <img
                              className="w-full h-32 object-cover cursor-pointer border border-base-100"
                              src={gif.images.fixed_height_downsampled.url}
                              alt={gif.images.fixed_height_downsampled.url}
                            />
                          </picture>
                        ) : null}
                      </div>
                    ))
                  : null}
                {gifs.length > 0 && !loading && !loadingMore ? (
                  <div className="p-2 sm:p-0">
                    <button
                      onClick={() => _handleLoadMore()}
                      className={`btn btn-outline ${
                        loadingMore && "opacity-50"
                      }`}
                      disabled={loadingMore}
                    >
                      {loadingMore ? (
                        <Loading />
                      ) : (
                        <div ref={ref}>Charger plus</div>
                      )}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
